import { getSelectedLanguage } from '@frontend/translate';
import { calculateAge } from '../../../common/utils/calculateAge';

type DisplayAgeProps = {
    value?: string | Date;
};

export function DisplayAge({ value }: Readonly<DisplayAgeProps>) {
    const { common } = getSelectedLanguage();

    return value ? `${calculateAge(value)} ${common.date_years}` : null;
}
